const messageMood = {
    VERY_BAD: 0,
    BAD:1,
    GOOD: 2,
    VERY_GOOD : 3,
    NONE: 4
}

export default messageMood;